export default __webpack_public_path__ + "static/media/bttn.sign in.7fb7ce01.svg";